export const TOASTER_ID_KEYS = {
  DEFAULT: "default",
  AUTH: {
    LOGIN: "@auth:login",
    LOGIN_SUCCESS: "@auth:login-success",
    LOGIN_REDIRECT: "@auth:login-redirect",
    NOT_ALLOWED: "@auth:not-allowed"
  }
} as const;
